import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../../shared/core2Config";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";
import { ApiResponseModel, ApiVisa } from "../../shared";
import {EntityCreditUtilizationModel} from '../../../../../../models/aggregates/company';
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CompanyEntitySalesUtilizedCreditLimitService extends BaseApiPublicLoginTemplateService<EntityCreditUtilizationModel, EntityCreditUtilizationModel, EntityCreditUtilizationModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/company-entity-sales-credit-limits/utilized-credit-limit";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/company-entity-sales-credit-limits/utilized-credit-limit";
    this.httpClient = http;
  }

  getEntityCreditUtilizationByLoginEntity(visa: ApiVisa, entityGuid: string, companyGuid: string, entityCreditLimitGuid: string): Observable<ApiResponseModel<EntityCreditUtilizationModel>> {
    let url = this.apiUrl + '/login-entity-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/login-entity-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;
    }

    return this.httpClient.get<ApiResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }

  getEntityCreditUtilizationByLoginEp(visa: ApiVisa, entityGuid: string, companyGuid: string, entityCreditLimitGuid: string): Observable<ApiResponseModel<EntityCreditUtilizationModel>> {
    let url = this.apiUrl + '/login-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/login-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;
    }

    return this.httpClient.get<ApiResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }

  getEntityCreditUtilizationBackoffice(visa: ApiVisa, entityGuid: string, companyGuid: string, entityCreditLimitGuid: string): Observable<ApiResponseModel<EntityCreditUtilizationModel>> {
    let url = this.apiUrl + '/backoffice-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep?entity_hdr_guid=' + entityGuid + '&comp_guid=' + companyGuid + '&entity_credit_limit_guid=' + entityCreditLimitGuid;
    }

    return this.httpClient.get<ApiResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }
}
